import MuChange from './mu-change.entity';
import { SosUpdateResponse } from '../sos-response';
import { ProdBaseESDoc } from '../types';

export interface MuChangeESDoc extends ProdBaseESDoc {
	change_num: string;
	char_first_name: string;
	char_last_name: string;
	description: string;
	episode_num: string;
	char_num: string;
}

export interface MuChangeUpdateResponse extends SosUpdateResponse {
	updated: {
		MuChange: MuChange[];
	};
}
